import React from "react";
import TitlePage from "../../../../app/Title/TitlePage/TitlePageView";
import Grid from "@material-ui/core/Grid";
import {Button} from "primereact/button";
import {Column} from "primereact/column";
import {DataTable} from "primereact/datatable";
import {Dialog} from "primereact/dialog";
import Paper from "@material-ui/core/Paper";
import {InputText} from "primereact/inputtext";
import LinearProgress from "@material-ui/core/LinearProgress";
import SubtitleLabel from "../../../../app/Title/SubtitleLabel/SubtitleLabelView";
import {Divider} from "@material-ui/core";

const SendAvailableDetailView = (props) => {
    return (
        <React.Fragment>
            <LinearProgress color="secondary" id="LinearProgressBar" hidden={!props.isLoading}/>
            <Paper elevation={5}
                   style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                <Grid container spacing={1}>
                    <Grid item xs={10}>
                        <TitlePage title="Operación \ Valores Disponibles PTM \ Enviar Detalle"/>
                    </Grid>
                    <Grid item xs={2}>
                        <Button
                            label="Buscar"
                            style={{'float': 'right'}}
                            onClick={props.getDataInstitutionDetail}/>
                    </Grid>
                    <Grid item xs={12}><Divider/></Grid>
                    <Grid item xs={12}>
                        {props.messagesGrowl}
                    </Grid>
                    <Grid item xs={12}>
                        <Button label="Enviar Disponibilidad"
                                style={{'float': 'right'}}
                                onClick={props.openSendEmail}
                                className="p-button-secondary"/>
                    </Grid>
                    <Grid item xs={12}>
                        <DataTable
                            ref={props.pageTable}
                            rows={10}
                            paginator={true}
                            value={props.dataInstitutionDetail}
                            selectionMode="single"
                            resizableColumns={true}
                            columnResizeMode={"fit"}>
                            <Column field="nomCorto" header="Institución" style={{textAlign: 'left'}} sortable={true}/>
                            <Column field="statusCarga" header="Estatus" style={{textAlign: 'left'}}
                                    body={props.formatStatus} sortable={true}/>
                        </DataTable>
                    </Grid>
                </Grid>
            </Paper>

            <Dialog visible={props.displayDialog} header={props.dialogHeader} modal={true}
                    onHide={props.onHideDialog} closable={false}
                    style={{width: "45%",}}>
                <div className="p-grid ">
                    <div className="p-col-12" >
                        <SubtitleLabel header="Correos Ocultos" isBold={true}/>
                        <InputText name="emailStr"
                                   onChange={props.onChangeTextDialog}
                                   value={props.emailStr}
                                   placeholder="Ex. soporte@mei.com.mx"/>

                    </div>
                    <div className="p-col-12" style={{padding: '.5em'}}>
                        <DataTable
                            ref={props.pageTableEm}
                            value={props.dataInstitutionSend}
                            paginator={true}
                            rows={10}
                            scrollHeight="200px"
                            selection={props.selectedInstitutions}
                            onSelectionChange={props.onSelectionChangeTable}
                            resizableColumns={true}
                            columnResizeMode={"fit"}>
                            <Column selectionMode="multiple" style={{width: '10%', textAlign: "center"}}/>
                            <Column field="nombreCorto" header="Institución" sortable={true}
                                    style={{textAlign: "left"}}/>
                        </DataTable>
                    </div>
                </div>
            </Dialog>
            {props.confMsg}
        </React.Fragment>
    )
};

export default SendAvailableDetailView;